import {Injectable} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {SnackBarComponent} from '../shared/components/ux/snack-bar/snack-bar.component';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private subject = new Subject<any>();
  private keepAfterRouteChange = false;
  closeLabel: string;
  constructor(
    private router: Router,
    private _snackBar: MatSnackBar,
    private translate: TranslateService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          this.keepAfterRouteChange = false;
        } else {
          this.clear();
        }
      }
    });
    this.translate.get('COMMON.CLOSE').subscribe((value) => {
      this.closeLabel = value;
    });
  }

  getAlert(): Observable<any> {
    return this.subject.asObservable();
  }

  success(message: string, keepAfterRouteChange = false) {
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.subject.next({ type: 'success', text: message });
  }

  error(message: string, keepAfterRouteChange = false) {
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.subject.next({ type: 'error', text: message });
  }

  clear() {
    this.subject.next({});
  }

  openSnackBar(value, snackClass) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      data: {
        value: value,
        status: snackClass,
      },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });
  }
  openSnackBarWarn(value, snackClass) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      data: {
        value: value,
        status: snackClass,
      },
      duration: 10000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
